import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useContext,
} from 'react';
import toast from 'react-hot-toast';
// import { checkEventStatus } from './eventTabs/funcCalls';
import streamComponentStyles from '../styles/streamComponentStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Slider from '@material-ui/core/Slider';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import lifecycleEs5 from 'page-lifecycle';
import Select from 'react-select';
import VolumeOffSharpIcon from '@material-ui/icons/VolumeOffSharp';
import FullscreenSharpIcon from '@material-ui/icons/FullscreenSharp';
import VolumeUpSharpIcon from '@material-ui/icons/VolumeUpSharp';
import { updateTour } from '../redux/watcheventTourSlice';

import { useDispatch, useSelector } from 'react-redux';
// import { updateEventStatus } from '../redux/eventStatusSlice';

// import {} from 'amazon-ivs-player';

import IVSPlayerContext from './../services/ivsPlayerContext';
import NoticeModal from './newfiles/NoticeModal';

const useStyles = makeStyles((theme) => streamComponentStyles(theme));

function StreamEvent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const watchEventTour = useSelector((state) => state.watcheventTour);
  const [plyrState, setPlyrState] = useState('first');
  const [dummy, setDummy] = useState(false);
  const [value, setValue] = useState(1);
  const timerLevel = 5000;

  // const eventStatus = useSelector((state) => state.eventStatus);

  const { IVSPlayer, IVSInstance } = useContext(IVSPlayerContext);

  const [qualityInList, setQualityInList] = useState([]);
  const [selectedQuality, setSelectedQuality] = useState({});
  const [hideQuality, setHideQuality] = useState(false);
  const containerRef = useRef();

  const [player, setPlayer] = useState();
  const timerID = useRef();
  const videoRef = useRef();
  const PLAYBACK_URL = props.url;

  const notActiveText = 'The live event is not active';

  const openTour = () => {
    dispatch(updateTour({ status: true }));
  };

  const upVolume = () => {
    videoRef.current.muted = false;
    setValue(1);
  };

  const downVolume = () => {
    videoRef.current.muted = true;
    setValue(0);
  };

  const handleChange = (event, newValue) => {
    // console.log(newValue);

    if (newValue === 1) {
      upVolume();
    } else if (newValue === 0) {
      downVolume();
    } else {
      setValue(newValue);
    }
  };

  const dummyTimedUpdate = () => {
    //dummy update of state to re-render to show muted/unmuted
    if (watchEventTour.isTourOpen) {
      return;
    }

    try {
      setTimeout(() => {
        setHideQuality((prevState) => !prevState);
      }, [3000]);
    } catch (error) {}
  };

  const readyPlyrState = () => {
    clearRetryTimeInterval();
    setPlyrState('working');
    // toast.success('Live Stream Ready');
    player.setAutoQualityMode(false);
    const qualityListTemp = player.getQualities();
    const leastQuality = player.getQualities().slice(-2).shift();
    qualityList(qualityListTemp);
    player.setQuality(leastQuality);
    setSelectedQuality({
      value: leastQuality,
      label: `${leastQuality?.height}P`,
      id: leastQuality?.name,
    });
    videoRef.current.muted = false;
    player.play();
    dummyTimedUpdate();
  };

  const playerEndedState = () => {
    toast.success('Live Stream Ended');
    setPlyrState(notActiveText);
    // player?.delete();
    retryWithTimeInterval();
  };

  const playerErrorState = (PlayerError) => {
    setPlyrState(notActiveText);
    clearRetryTimeInterval();
    retryWithTimeInterval();
  };

  const retryFunc = async () => {
    await player?.load(PLAYBACK_URL);
    // removeListn();
    // startAwsPlay();
  };

  const clearRetryTimeInterval = (from) => {
    // 'clearing interval', timerID?.current
    clearTimeout(timerID?.current);
  };
  const retryWithTimeInterval = (from) => {
    clearRetryTimeInterval();
    // 'timer started', timerID.current
    timerID.current = setTimeout(() => {
      // 'timer running', timerID.current
      retryFunc();
    }, timerLevel);
  };

  const startAwsPlay = useCallback(() => {
    player.addEventListener('Ready', readyPlyrState);
    player.addEventListener('Ended', playerEndedState);
    player.addEventListener('PlayerError', playerErrorState);
  }, [player]);

  const removeListn = () => {
    player.removeEventListener('Ready', readyPlyrState);
    player.removeEventListener('Ended', playerEndedState);
    player.removeEventListener('PlayerError', playerErrorState);
  };

  const initiatePlayer = () => {
    if (IVSPlayer.isPlayerSupported) {
      if (player) {
        // 'just loading the player', player
        player.attachHTMLVideoElement(videoRef.current);
        player.load(PLAYBACK_URL);
      } else {
        // 'saving created instance
        setPlayer(IVSInstance);
      }
    } else {
      toast.dismiss();
      toast.error('Browser not supported');
    }
  };

  useEffect(() => {
    // 'initializing new player1'
    initiatePlayer();
    return () => {
      clearRetryTimeInterval();
    };
  }, [player]);

  const dummyUpdateReq = () => {
    if (!videoRef.current.muted) {
      dummy || setDummy(true);
    }
    if (videoRef.current.muted) {
      if (!dummy) {
        setDummy(false);
      }
    }
  };

  useEffect(() => {
    videoRef.current.controls = false;
    // videoRef.current.muted = false;
    // updating dummy states below to re-render and show notice modal'
    dummyUpdateReq();
  });

  useEffect(() => {
    if (player) {
      // 'starting new player2 aws'
      startAwsPlay();
      return;
    }

    return () => {
      if (player) {
        clearRetryTimeInterval();
        removeListn();
      }
    };
  }, [player]);

  useEffect(() => {
    return () => {
      if (player) removeListn();
    };
  }, [player]);

  useEffect(() => {
    openTour();

    return () => {
      clearRetryTimeInterval();
    };
  }, []);

  const renderRetry = () => {
    //show connecting to live event except in 'working' state
    return (
      <div className={classes.retryContStyles}>
        <Typography className={classes.greyColor}>{plyrState}</Typography>
      </div>
    );
  };

  const browserHandlerFunc = (event) => {
    if (event.newState === 'terminated' || event.newState === 'frozen') {
      clearRetryTimeInterval();
      player?.delete();
    }
  };

  // useEffect(() => {
  //   try {
  //     player.setRebufferToLive(true);
  //   } catch (error) {
  //     console.log(error, 'live err');
  //   }
  // });

  useEffect(() => {
    lifecycleEs5.addEventListener('statechange', browserHandlerFunc);
    window.addEventListener('beforeunload', () => {
      clearRetryTimeInterval();
    });
    return () => {
      lifecycleEs5.removeEventListener('statechange', browserHandlerFunc);
      window.removeEventListener('beforeunload', () => {
        clearRetryTimeInterval();
      });
      try {
        clearRetryTimeInterval();
      } catch (error) {}
    };
  }, []);

  useEffect(() => {
    return () => {
      clearRetryTimeInterval();
    };
  }, []);

  const qualityList = (quality) => {
    const qualityInList = quality.map((each, index) => {
      // console.log(each, 'video qualities available');
      const x = {
        value: each,
        label: `${each?.height}P`,
        id: each?.name,
      };
      return x;
    });
    setQualityInList(qualityInList);
  };

  const qualitySelectionFunc = (selectedOption) => {
    setSelectedQuality(selectedOption);
    player.setQuality(selectedOption.value);
  };

  const selectQualityNode = () => {
    if (hideQuality) return null;
    return (
      <div className={classes.qualityContainer} data-tut='reactour_quality'>
        <Select
          value={selectedQuality?.label ? selectedQuality : null}
          options={qualityInList}
          placeholder='720P'
          styles={customStyles}
          onChange={qualitySelectionFunc}
        />
      </div>
    );
  };

  function isInFullScreen() {
    const document = window.document;
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  }

  const doFullScreen = (elem) => {
    try {
      if (containerRef.current.requestFullScreen) {
        containerRef.current.requestFullScreen();
      } else if (containerRef.current.mozRequestFullScreen) {
        containerRef.current.mozRequestFullScreen();
      } else if (containerRef.current.webkitRequestFullScreen) {
        containerRef.current.webkitRequestFullScreen();
      } else if (containerRef.current.msRequestFullscreen) {
        containerRef.current.msRequestFullscreen();
      }
    } catch (error) {
      alert(error);
    }
  };

  const undoFullScreen = () => {
    try {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
    } catch (error) {
      alert(error);
    }
  };

  function toggleFullScreen() {
    if (isInFullScreen()) {
      undoFullScreen();
    } else {
      doFullScreen(containerRef.current);
    }
  }

  const changeVolume = (value) => {
    player?.setVolume(value);
  };

  useEffect(() => {
    changeVolume(value);
  }, [value, player]);

  const showSpeaker = () => {
    return (
      <div className={classes.iconsContainer}>
        <div className={classes.volumeCont} data-tut='reactour_sound'>
          {videoRef.current?.muted || !value ? (
            <IconButton onClick={upVolume} className={classes.iconBtnContainer}>
              <VolumeOffSharpIcon className={classes.iconOffClass} />
            </IconButton>
          ) : (
            <IconButton
              onClick={downVolume}
              className={classes.iconBtnContainer}
            >
              <VolumeUpSharpIcon className={classes.iconOnClass} />
            </IconButton>
          )}
          {!qualityInList.length ? null : (
            <Slider
              value={value}
              onChange={handleChange}
              aria-labelledby='continuous-slider'
              step={0.1}
              max={1.0}
              min={0.0}
              className={classes.volSliderStyle}
              // style={{ width: 120,  }}
            />
          )}
        </div>
        <IconButton
          onClick={toggleFullScreen}
          className={classes.iconBtnContainer}
        >
          <FullscreenSharpIcon className={classes.iconOnClass} />
        </IconButton>
      </div>
    );
  };

  const onMouseLeave = () => {
    if (watchEventTour.isTourOpen) {
      setHideQuality(false);
      return;
    }
    setHideQuality(true);
    return;
  };

  const onMouseEnter = () => {
    setHideQuality(false);
  };

  return (
    <Container
      className={classes.mainContainer}
      ref={containerRef}
      component='div'
      onMouseOver={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* {check()} */}
      {videoRef.current?.muted && plyrState !== notActiveText ? (
        <NoticeModal onClick={upVolume} />
      ) : null}
      {plyrState === notActiveText ? renderRetry() : null}
      {/* {qualityInList.length ? selectQualityNode() : null} */}
      {selectQualityNode()}
      {hideQuality ? null : showSpeaker()}
      <video
        ref={videoRef}
        className={classes.videoClass}
        muted
        playsInline
        crossOrigin='anonymous'
        disablePictureInPicture
      ></video>
    </Container>
  );
}

export default StreamEvent;

const customStyles = {
  control: (base) => ({
    ...base,
    width: 70,
    height: 'auto',
    flex: 1,
    borderColor: '#767676',
    borderWidth: 2,
    borderStyle: 'solid',
    borderRadius: 20,
    backgroundColor: 'transparent',
    margin: 5,
  }),

  placeholder: (state) => ({
    position: 'absolute',
    color: '#767676',
  }),
  indicatorsContainer: (state) => ({
    position: 'absolute',
    right: 0,
  }),
  singleValue: (state) => ({}),
};

// code: 404
// displayCode: 157
// message: "Failed to load playlist"
// source: "MasterPlaylist"
// type: "ErrorNotAvailable"
